import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VigilanceComplaintForm from '../../components/VigilanceComplaintForm';

const CreateVigilanceView = () => {
  const navigate = useNavigate();
  const [userComplaints, setUserComplaints] = useState([]);

  const handleComplaintSubmit = (complaintData) => {
    // Add the new complaint to the list
    const newComplaint = {
      id: Date.now(),
      complaintNumber: complaintData.complaintNumber,
      status: 'Under Review',
      submittedDate: new Date().toLocaleDateString(),
      description: complaintData.complaintDetails,
      priority: 'Medium',
      name: complaintData.name,
      email: complaintData.email,
      mobileNumber: complaintData.mobileNumber
    };

    setUserComplaints(prev => [newComplaint, ...prev]);
    
    // Store in localStorage for persistence
    const existingComplaints = JSON.parse(localStorage.getItem('user_complaints') || '[]');
    const updatedComplaints = [newComplaint, ...existingComplaints];
    localStorage.setItem('user_complaints', JSON.stringify(updatedComplaints));
  };

  const handleCancelComplaintForm = () => {
    navigate('/vigilance-dashboard');
  };

  return (
    <div className="max-w-7xl mx-auto">
      <VigilanceComplaintForm
        onSubmit={handleComplaintSubmit}
        onCancel={handleCancelComplaintForm}
      />
    </div>
  );
};

export default CreateVigilanceView;
